// @ts-nocheck
import { Empty } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Dialog } from "react-vant";
import { newsApi } from "../../../../api/news-api";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function CenterPage({
  coinListData,
  leverorders,
  closeorder,
  addnumFun,
  strutcnumFun,
  editLossWinFun,
}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");
  const [index, setindex] = useState(1);
  //加 减 改
  const [tempData, settempData] = useState({} as any);
  const [addnum, setaddnum] = useState("");
  const [addnumVisible, setaddnumVisible] = useState(false);
  const [strutcnum, setstrutcnum] = useState("");
  const [strutcnumVisible, setstrutcnumVisible] = useState(false);
  const [lossnum, setlossnum] = useState("");
  const [winnum, setwinnum] = useState("");
  const [editLossWinVisible, seteditLossWinVisible] = useState(false);

  const getboomPrice = (type, bsnum, nowTab) => {
    nowTab = nowTab?.replace("/USDT", "")?.toLowerCase();
    const openPrice = coinListData[nowTab]?.close;
    let price = 0;
    if (type == 1) {
      price = openPrice * (1 - 1 / bsnum + 0.005);
    }
    if (type == 2) {
      price = openPrice * (1 + 1 / bsnum - 0.005);
    }
    return price;
  };

  const getNode1 = () => {
    const nodes = [];
    const leverorderstemp = leverorders.filter(
      (data) => data.status === (index == 1 ? 1 : 2)
    );
    for (let index = 0; index < leverorderstemp.length; index++) {
      const data = leverorderstemp[index];
      const priceyd = (
        data.num *
        data.fold *
        ((data.buyprice -
          coinListData[data.coinname.replace("/USDT", "").toLowerCase()]
            ?.close) /
          data.buyprice)
      ).toFixed(4);
      const node = (
        <li className="mb-4" key={data.id}>
          <div className="bg-neutral-800 rounded-xl overflow-hidden shadow-card">
            <div 
              className="p-4"
              onClick={() => {
                const sendData = {
                  orderNo: data.orderNo,
                  coinname: data.coinname,
                  num: data.num,
                  ploss: data.ploss,
                  buytime: data.buytime,
                  status: data.status,
                  isWin: data.isWin,
                };
                if (data.status == 1) {
                  return;
                }
                navigate(
                  `/marketOrderInfo/${data.id}?data=${JSON.stringify(sendData)}`
                );
              }}
            >
              <div className="grid grid-cols-3 gap-3">
                <div className="flex flex-col space-y-2">
                  <div className="text-neutral-400 text-xs">{translate(getText("交易品種"))}</div>
                  <div className="text-sm font-semibold">{data.coinname}</div>
                  <div className="text-neutral-400 text-xs">{translate(getText("保证金"))}</div>
                  <div className="text-sm font-semibold">{data.num?.toFixed(4)}</div>
                  <div className="text-neutral-400 text-xs">{translate(getText("倍数"))}</div>
                  <div className="text-sm font-semibold">{data.fold}</div>
                </div>
                
                <div className="flex flex-col space-y-2">
                  <div className="text-neutral-400 text-xs">{translate(getText("開倉價"))}</div>
                  <div className="text-sm font-semibold">{data.buyprice?.toFixed(4)}</div>
                  <div className="text-neutral-400 text-xs">{translate(getText(data.status == 1 ? "現價" : "结算價"))}</div>
                  <div className="text-sm font-semibold">
                    {data.status == 1 &&
                      coinListData[
                        data.coinname.replace("/USDT", "").toLowerCase()
                      ]?.close}
                    {data.status != 1 && data.sellprice}
                  </div>
                  <div className="text-neutral-400 text-xs">{translate(getText("强平价格"))}</div>
                  <div className="text-sm font-semibold">{data.boomPrice?.toFixed(4)}</div>
                </div>
                
                <div className="flex flex-col space-y-2">
                  <div className="text-neutral-400 text-xs">{translate(getText("方向"))}</div>
                  <div className={data.hyzd == 1 ? "text-success text-sm font-semibold" : "text-danger text-sm font-semibold"}>
                    {translate(getText(data.hyzd == 1 ? "看漲" : "看跌"))}
                  </div>
                  <div className="text-neutral-400 text-xs">{translate(getText("止損價"))}</div>
                  <div className="text-sm font-semibold">{data.lossPrice}</div>
                  <div className="text-neutral-400 text-xs">{translate(getText("止盈價"))}</div>
                  <div className="text-sm font-semibold">{data.winPrice}</div>
                </div>
              </div>
              
              <div className="mt-4 pt-3 border-t border-neutral-700">
                {data.status == 1 && (
                  <div className="flex justify-between items-center">
                    <div className="text-neutral-400 text-xs">{translate(getText("預期收益"))}</div>
                    <div 
                      className={
                        (priceyd < 0 && data.hyzd == 1) || (priceyd > 0 && data.hyzd == 2)
                          ? "text-danger font-bold"
                          : "text-success font-bold"
                      }
                    >
                      {(priceyd < 0 && data.hyzd == 1) || (priceyd > 0 && data.hyzd == 2)
                        ? Math.abs(priceyd)
                        : -Math.abs(priceyd)}
                    </div>
                  </div>
                )}
                {data.status == 2 && (
                  <div className="flex justify-between items-center">
                    <div className="text-neutral-400 text-xs">{translate(getText("收益"))}</div>
                    <div
                      className={data.isWin == 1 ? "text-success font-bold" : "text-danger font-bold"}
                    >
                      {data.isWin == 1 ? "+" : "-"}
                      {Math.abs(data.ploss)}
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {data.status == 1 && (
              <div className="grid grid-cols-4 divide-x divide-neutral-700 bg-neutral-900">
                <button
                  className="py-3 text-center text-primary-light text-sm font-medium hover:bg-neutral-800 transition"
                  onClick={(e) => {
                    Dialog.confirm({
                      title: translate(getText("提示")),
                      message: translate(getText("是否确认平仓？")),
                      cancelButtonText:translate(getText("取消")),
                      confirmButtonText:translate(getText("确认")),
                      onConfirm: () => {
                        closeorder(
                          data.id,
                          data?.num,
                          (priceyd < 0 && data.hyzd == 1) ||
                            (priceyd > 0 && data.hyzd == 2)
                            ? Math.abs(priceyd)
                            : -Math.abs(priceyd)
                        );
                      },
                    });
                  }}
                >
                  {translate(getText("平倉"))}
                </button>
                <button
                  className="py-3 text-center text-primary-light text-sm font-medium hover:bg-neutral-800 transition"
                  onClick={() => {
                    settempData(data);
                    setaddnumVisible(true);
                    setaddnum("");
                  }}
                >
                  {translate(getText("加仓"))}
                </button>
                <button
                  className="py-3 text-center text-primary-light text-sm font-medium hover:bg-neutral-800 transition"
                  onClick={() => {
                    settempData(data);
                    setstrutcnumVisible(true);
                    setstrutcnum("");
                  }}
                >
                  {translate(getText("减仓"))}
                </button>
                <button
                  className="py-3 text-center text-primary-light text-sm font-medium hover:bg-neutral-800 transition"
                  onClick={() => {
                    settempData(data);
                    seteditLossWinVisible(true);
                    setlossnum(data?.lossPrice);
                    setwinnum(data?.winPrice);
                  }}
                >
                  {translate(getText("設定止盈止損"))}
                </button>
              </div>
            )}
          </div>
        </li>
      );
      nodes.push(node);
    }
    return (
      <ul className="list-none p-0">
        {nodes.length === 0 && (
          <Empty
            description={translate(getText("暂无数据"))}
            className="pt-10"
          />
        )}
        {nodes}
      </ul>
    );
  };

  const getNode2 = () => {
    const nodes = [];
    const leverorderstemp = leverorders.filter(
      (data) => data.status === (index == 2 ? 2 : 3)
    );
    for (let index = 0; index < leverorderstemp.length; index++) {
      const data = leverorderstemp[index];
      const node = (
        <li className="mb-3" key={data.id}>
          <div className="bg-neutral-800 rounded-lg overflow-hidden shadow-card">
            <div 
              className="p-4"
              onClick={() => {
                const sendData = {
                  orderNo: data.orderNo,
                  coinname: data.coinname,
                  num: data.num,
                  ploss: data.ploss,
                  buytime: data.buytime,
                  status: data.status,
                  isWin: data.isWin,
                };
                navigate(
                  `/marketOrderInfo/${data.id}?data=${JSON.stringify(sendData)}`
                );
              }}
            >
              <div className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <span className="text-white font-medium">{data.coinname}</span>
                  <span className={`ml-2 text-xs px-1.5 py-0.5 rounded ${data.hyzd == 1 ? "bg-success bg-opacity-20 text-success" : "bg-danger bg-opacity-20 text-danger"}`}>
                    {translate(getText(data.hyzd == 1 ? "看漲" : "看跌"))}
                  </span>
                </div>
                <div className="text-neutral-400 text-xs">{data.buytime?.substring(0, 16)}</div>
              </div>
              
              <div className="flex mb-2">
                <div className="flex-1">
                  <div className="text-neutral-400 text-xs mb-1">{translate(getText("保证金"))}</div>
                  <div className="font-medium text-white">
                    {data.num.toFixed(4)} <span className="text-xs text-neutral-400">USDT</span>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-neutral-400 text-xs mb-1">{translate(getText("盈虧"))}</div>
                  <div className={`font-medium ${data.isWin == 1 ? "text-success" : "text-danger"}`}>
                    {data.isWin == 1 ? "+" : "-"}{Math.abs(data.ploss)}
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-3 border-t border-neutral-700 pt-2">
                <div>
                  <div className="text-neutral-400 text-xs mb-1">{translate(getText("開倉價"))}</div>
                  <div className="text-white text-sm">{data.buyprice}</div>
                </div>
                <div>
                  <div className="text-neutral-400 text-xs mb-1">{translate(getText("倍数"))}</div>
                  <div className="text-white text-sm">{data.fold}X</div>
                </div>
                <div>
                  <div className="text-neutral-400 text-xs mb-1">{translate(getText("操作"))}</div>
                  <div>
                    <span className="text-primary-light text-sm">{translate(getText("詳情"))}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      );
      nodes.push(node);
    }
    return (
      <ul className="list-none p-0">
        {nodes.length === 0 && (
          <Empty
            description={translate(getText("暂无数据"))}
            className="pt-10 text-neutral-400"
          />
        )}
        {nodes}
        {nodes.length > 0 && (
          <div className="text-center text-neutral-500 text-xs py-3">
            {translate(getText("暂无更多了"))}
          </div>
        )}
      </ul>
    );
  };

  return (
    <div className="flex flex-col h-full">
      <div className="bg-neutral-800 sticky top-0 z-10">
        <div className="flex w-full">
          <div
            className={`flex-1 text-center py-3 font-medium text-sm ${
              index === 1 ? "text-primary-light" : "text-neutral-400"
            }`}
            onClick={() => setindex(1)}
          >
            {translate(getText("在持"))}
            {index === 1 && <div className="h-0.5 w-5 bg-primary mx-auto mt-2 rounded-full"></div>}
          </div>
          <div
            className={`flex-1 text-center py-3 font-medium text-sm ${
              index === 2 ? "text-primary-light" : "text-neutral-400"
            }`}
            onClick={() => setindex(2)}
          >
            {translate(getText("已成交"))}
            {index === 2 && <div className="h-0.5 w-5 bg-primary mx-auto mt-2 rounded-full"></div>}
          </div>
          <div
            className={`flex-1 text-center py-3 font-medium text-sm ${
              index === 3 ? "text-primary-light" : "text-neutral-400"
            }`}
            onClick={() => setindex(3)}
          >
            {translate(getText("已平倉"))}
            {index === 3 && <div className="h-0.5 w-5 bg-primary mx-auto mt-2 rounded-full"></div>}
          </div>
        </div>
      </div>

      <div className="pt-4 px-2 flex-1 overflow-auto">
        {index === 1 && getNode1()}
        {index === 2 && getNode2()}
        {index === 3 && getNode2()}
      </div>

      {/* 加仓 dialog */}
      <Dialog
        visible={addnumVisible}
        title={translate(getText("加仓"))}
        showCancelButton
        confirmButtonText={translate(getText("确定"))}
        cancelButtonText={translate(getText("取消"))}
        onConfirm={() => {
          addnumFun({ lid: tempData.id, num: addnum });
          setaddnumVisible(false);
        }}
        onCancel={() => {
          setaddnumVisible(false);
        }}
      >
        <div className="flex flex-col p-4">
          <input
            className="bg-neutral-800 border border-neutral-700 rounded py-2 px-3 text-white mb-2"
            placeholder={translate(getText("请输入加仓的数量"))}
            onChange={(e) => {
              setaddnum(e.target.value);
            }}
            type="number"
            value={addnum}
          />
        </div>
      </Dialog>

      {/* 减仓 dialog */}
      <Dialog
        visible={strutcnumVisible}
        title={translate(getText("减仓"))}
        showCancelButton
        confirmButtonText={translate(getText("确定"))}
        cancelButtonText={translate(getText("取消"))}
        onConfirm={() => {
          strutcnumFun({ lid: tempData.id, num: strutcnum });
          setstrutcnumVisible(false);
        }}
        onCancel={() => {
          setstrutcnumVisible(false);
        }}
      >
        <div className="flex flex-col p-4">
          <input
            className="bg-neutral-800 border border-neutral-700 rounded py-2 px-3 text-white mb-2"
            placeholder={translate(getText("请输入减仓的数量"))}
            onChange={(e) => {
              setstrutcnum(e.target.value);
            }}
            type="number"
            value={strutcnum}
          />
        </div>
      </Dialog>

      {/* 设置止盈止损 dialog */}
      <Dialog
        visible={editLossWinVisible}
        title={translate(getText("設定止盈止損"))}
        showCancelButton
        confirmButtonText={translate(getText("确定"))}
        cancelButtonText={translate(getText("取消"))}
        onConfirm={() => {
          editLossWinFun({
            lid: tempData.id,
            lossPrice: lossnum,
            winPrice: winnum,
          });
          seteditLossWinVisible(false);
        }}
        onCancel={() => {
          seteditLossWinVisible(false);
        }}
      >
        <div className="flex flex-col p-4">
          <div className="mb-3">
            <div className="text-neutral-400 text-sm mb-1">{translate(getText("止损价"))}</div>
            <input
              className="bg-neutral-800 border border-neutral-700 rounded py-2 px-3 text-white w-full"
              placeholder={translate(getText("请输入止损价格"))}
              onChange={(e) => {
                setlossnum(e.target.value);
              }}
              type="number"
              value={lossnum}
            />
          </div>
          <div>
            <div className="text-neutral-400 text-sm mb-1">{translate(getText("止盈价"))}</div>
            <input
              className="bg-neutral-800 border border-neutral-700 rounded py-2 px-3 text-white w-full"
              placeholder={translate(getText("请输入止盈价格"))}
              onChange={(e) => {
                setwinnum(e.target.value);
              }}
              type="number"
              value={winnum}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
